<template>
  <div class="md-layout">
    <div class="mx-auto">
      <div class="header text-center">
        <ValidationObserver ref="form">
          <form @submit.prevent="validate">
            <h3 class="title">Restauración de contraseña</h3>
            <p class="category">
              Todo listo para cambiar tu contraseña, digítala a continuación.
            </p>
            <ValidationProvider
              name="password"
              rules="required|confirmed:passConfirmation|min:6"
              v-slot="{ passed, failed }"
            >
              <md-field
                :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
              >
                <label>Contraseña</label>
                <md-input v-model="password" type="password"> </md-input>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </ValidationProvider>
            <ValidationProvider
              vid="passConfirmation"
              rules="required|min:6"
              v-slot="{ passed, failed }"
            >
              <md-field
                :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
              >
                <label>Confirmar Contraseña</label>
                <md-input v-model="passConfirmation" type="password">
                </md-input>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </ValidationProvider>
            <md-button
              :disabled="loading"
              class="md-layout-item md-info"
              @click.prevent="actionEvent"
            >
              Cambiar
            </md-button>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>
<script>
import gql from "graphql-tag";
import Swal from "sweetalert2";
import Constants from "../../constants";
import { extend } from "vee-validate";
import { required, email, confirmed } from "vee-validate/dist/rules";
import { SlideYDownTransition } from "vue2-transitions";

extend("email", email);
extend("required", required);
extend("confirmed", confirmed);

export default {
  components: {
    SlideYDownTransition
  },
  props: {},
  data: function() {
    return {
      password: null,
      passConfirmation: null,
      Constants: Constants,
      loading: false
    };
  },
  created() {},
  methods: {
    actionEvent() {
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: gql`
            mutation updatePassword($password: String!, $token: String!) {
              updatePassword(password: $password, token: $token)
            }
          `,
          variables: {
            password: this.password,
            token: this.$route.params.token
          },
          update: (cache, mutationResult) => {
            this.loading = false;
            var updated = mutationResult.data.updatePassword;
            if (updated)
              Swal.fire({
                title: "Actualizado",
                html: "Se ha realizado la actualización de manera correcta.",
                confirmButtonClass: "md-button md-primary",
                buttonsStyling: false
              }).then(() => this.$router.push("/login"));
          }
        })
        .catch(error => {
          this.loading = false;
          Constants.catchError(
            error,
            this.$apollo.provider.defaultClient,
            this,
            true
          );
        });
    }
  }
};
</script>
<style></style>
